import SlideAPI from '@/api/slide'
import AudienceAPI from '@/api/audience'
import ReactionAPI from '@/api/reaction'
import SlideOptionApi from '@/api/slide-option'
import ChatApi from '@/api/chat'
import QuestionApi from '@/api/question'
import UserApi from '@/api/user'
import PrivateFeedbackApi from '@/api/private-feedback'
import Answers from '@/api/answers'
import PresentationAudienceLatency from '@/api/presentation-audience-latency'
import AttendedPresentationsApi from '@/api/attended-presentations'
import kvSyncApi from '@/api/kvSync'
import presentationAttribute from './presentation-attribute'

const initResources = () => {
  SlideAPI.initResource()
  AudienceAPI.initResource()
  ReactionAPI.initResource()
  SlideOptionApi.initResource()
  ChatApi.initResource()
  QuestionApi.initResource()
  UserApi.initResource()
  PrivateFeedbackApi.initResource()
  Answers.initResource()
  PresentationAudienceLatency.initResource()
  AttendedPresentationsApi.initResource()
  kvSyncApi.initResource()
  presentationAttribute.initResource()
}

export default {
  initResources,
}
